var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ spacing: _vm.addSpacingBetweenItems }},[_vm._t("default",null,{"isValid":_vm.isValid,"errors":_vm.errors})],2)}
var staticRenderFns = []

export { render, staticRenderFns }